import { useState, useEffect } from "react";
import { UserLoginData } from "../components/common/charts/Enums";

export const useCurrencySymbol = () => {
  const [currencySymbol, setCurrencySymbol] = useState(() => sessionStorage.getItem(UserLoginData.currency_symbol) || "$");

  useEffect(() => {
    const symbol = sessionStorage.getItem(UserLoginData.currency_symbol);
    if (symbol) {
      setCurrencySymbol(symbol);
    }
  }, []);

  return currencySymbol;
};
